import translate from "./translations";

export const MenuItemLabel = ({
  defaultValue,
  key,
}: {
  defaultValue: string;
  key: string;
}) => {
  return { id: key, title: <p>{translate(key, defaultValue)}</p> };
};

export const preventNonNumericInput = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  let value = event.target.value;
  // Remove all characters except digits and dots
  value = value.replace(/[^0-9.]/g, "");
  // Only allow one dot
  const parts = value.split(".");
  if (parts.length > 2) {
    value = parts[0] + "." + parts.slice(1).join("");
  }
  // Prevent leading dot (".5" is allowed, but "..5" is not)
  if (value.startsWith("..")) {
    value = value.replace(/^\.+/, ".");
  }
  event.target.value = value;
};

export const removeUnnecessaryZeros = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  const value = event.target.value;
  event.target.value = value.replace(/\b0+/g, "");
};
